import React, { useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { AppContext } from '@prisjakt/ui-app-context';

import { AppState } from '../../../reducers';
import { logoutRequest } from '../actions';
import listActions from '../../sidebar/actions/lists';

import Menu from '../../../components/menu-new';
import MenuItem from '../../../components/menu-new/components/menu-item';
import { Grow, Position } from '../../../components/menu-new/types';

import * as S from './styles';

type OwnProps = {
  position: Position;
  grow: Grow;
  toggleElement: React.ReactElement;
  toggleElementStyles?: {};
};

type StateProps = {
  isAuthenticated: boolean;
};

type DispatchProps = {
  dispatchLogoutRequest: (message: string) => void;
  closeLists: () => void;
  selectList: (id: number | null) => void;
};

type Props = OwnProps & DispatchProps & StateProps;

const AccountMenu = ({
  isAuthenticated = false,
  dispatchLogoutRequest,
  position,
  grow,
  toggleElement,
  toggleElementStyles,
  closeLists,
  selectList,
}: Props) => {
  const { t } = useContext(AppContext);

  const onLogout = useCallback(() => {
    selectList(null);
    closeLists();
    dispatchLogoutRequest(t('account', 'logout.successful'));
  }, [selectList, closeLists, dispatchLogoutRequest, t]);

  return (
    <React.Fragment>
      <Menu
        position={position}
        grow={grow}
        width="200px"
        toggleElement={toggleElement}
        toggleElementStyles={toggleElementStyles}
      >
        {!isAuthenticated ? (
          <S.Buttons>
            <S.AccountButton color="primary" component={<Link to="/login" />}>
              {t('account', 'menu.not-logged-in-button')}
            </S.AccountButton>

            <S.AccountButton
              color="primary"
              variant="outlined"
              component={<Link to="/signup" />}
            >
              {t('account', 'signup.submit-button')}
            </S.AccountButton>
          </S.Buttons>
        ) : (
          <div>
            <MenuItem href="/account/settings">
              {t('account', 'menu.settings')}
            </MenuItem>

            <S.Buttons>
              <S.AccountButton
                color="secondary"
                variant="outlined"
                onClick={onLogout}
              >
                {t('account', 'menu.logout-button')}
              </S.AccountButton>
            </S.Buttons>
          </div>
        )}
      </Menu>
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.areas.account.isAuthenticated,
});

const dispatchActions = {
  dispatchLogoutRequest: logoutRequest,
  closeLists: listActions.closeLists,
  selectList: listActions.selectList,
};

export default connect(mapStateToProps, dispatchActions)(AccountMenu);
